import moment from 'moment'

export function convertTimeToString(dateTime) {
    if (dateTime) {
        var date = new Date(dateTime)
        let hours = '' + date.getHours()
        let minutes = '' + date.getMinutes()

        if (hours.length < 2) hours = '0' + hours
        if (minutes.length < 2) minutes = '0' + minutes

        return hours + ':' + minutes
    }
}

export function revertStringToTime(timeStr) {
    if (timeStr) {
        return moment(timeStr, 'HH:mm').toDate()
    }
}

export function formatDate(date) {
    return date ? moment(date).format(moment.HTML5_FMT.DATE) : null
}

export function isValidDate(dateString) {
    // First check for the pattern
    if (!/^\d{1,2}-\d{1,2}-\d{4}$/.test(dateString)) return false

    // Parse the date parts to integers
    var parts = dateString.split('-')
    var day = parseInt(parts[0], 10)
    var month = parseInt(parts[1], 10)
    var year = parseInt(parts[2], 10)

    // Check the ranges of month and year
    if (year < 1000 || year > 3000 || month === 0 || month > 12) return false

    var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

    // Adjust for leap years
    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0))
        monthLength[1] = 29

    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1]
}
